export function getCurrentDomain(): string {
  const { hostname } = window.location;
  const stage = '.qa.sravni-team.ru';
  const production = '.sravni.ru';

  if (hostname.indexOf(stage) >= 0) {
    return stage;
  } else if (hostname.indexOf('localhost') >= 0) {
    return hostname;
  }

  return production;
}

export function setRegionCookie(routeGar: string): void {
  const domain = getCurrentDomain();
  const date = new Date();

  date.setFullYear(date.getFullYear() + 1);
  document.cookie = `_SLv2_=${routeGar}; domain=${domain}; path=/; expires=${date.toUTCString()}`;
}
